/**
 * Juuni AI Constants
 *
 * Centralized configuration for all thresholds, limits, and magic numbers.
 * When backend is connected, these values can be fetched from a config API
 * instead of being hardcoded. This file is the single source of truth
 * for any value that affects business logic or UI behavior.
 */

// ===== STREAK =====
export const STREAK = {
  BADGE_MIN: 4,           // Minimum weeks to show streak badge on profile
  GOLD_THRESHOLD: 8,      // Weeks to earn gold badge (vs. teal)
  QUALITY_THRESHOLD: 90,  // Min quality % to maintain streak (backend validates)
};

// ===== CRAFT SCORE =====
export const CRAFT_SCORE = {
  WEIGHTS: {
    precision: 0.30,
    consistency: 0.25,
    edgeCases: 0.25,
    knowledgeSharing: 0.20,
  },
  SPRINT_THRESHOLD: 93.0,  // Team Craft Score needed to clear a sprint
};

// ===== REWARDS =====
export const REWARDS = {
  CASH_BONUS: 150,              // $ per member for Craft Sprint clear
  RATE_BOOST_PERCENT: 10,       // % rate increase
  RATE_BOOST_HOURS: 6,          // Active work hours for rate boost
  FACILITATOR_BONUS: 75,        // $ bonus for facilitator if team clears
  PRIORITY_ACCESS_HOURS: 12,    // Hours early that priority access annotators see jobs
};

// ===== TEAM APPLICATION =====
export const TEAM_APP = {
  ACCEPTANCE_THRESHOLD: 3,  // Teammates needed to accept for team application
};

// ===== REFERRAL =====
export const REFERRAL = {
  EXPIRY_DAYS: 90,          // Days before uncompleted referral expires
  REFEREE_BONUS: 50,        // $ welcome bonus for referee
};

// ===== MATCH =====
export const MATCH = {
  DISPLAY_THRESHOLD: 90,    // Min match % to display on job cards (currently hidden)
};

// ===== JOBS =====
export const JOBS = {
  MAX_RATE_FILTER: 100,     // Default max rate for filter dropdown
};

// ===== APPLICATION STAGE CONFIG =====
// Phase 18.1.3 (2026-04-29 audit-fix): migrated from src/data/jobs.js mock
// data so the live ApplicationStage display labels live with other
// constants instead of with demo job data. Phase 18 forensic audit caught
// this scope gap (jobs.js was a deletion target but stageConfig had real
// consumers; needed to be moved to a real constants module first).
export const stageConfig = {
  applied:           { label: 'Applied',         color: 'var(--text-muted)',     order: 0 },
  under_review:      { label: 'Under Review',    color: 'var(--accent-blue)',    order: 1 },
  assessment:        { label: 'Trial Task',      color: 'var(--accent-gold)',    order: 2 },
  skills_evaluation: { label: 'Trial Task',      color: 'var(--accent-purple)',  order: 2.5 },
  accepted:          { label: 'Accepted',        color: 'var(--accent-teal)',    order: 3 },
  started:           { label: 'Started',         color: '#5dcaa5',               order: 4 },
  active:            { label: 'Active',          color: 'var(--accent-teal)',    order: 4 },
  not_selected:      { label: 'Not Selected',    color: 'var(--text-muted)',     order: 5 },
  withdrawn:         { label: 'Withdrawn',       color: 'var(--text-tertiary)',  order: 6 },
};
